"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
var _AppLoader = _interopRequireDefault(require("../core/AppLoader"));
var _useSnorreTheme = _interopRequireDefault(require("../utils/useSnorreTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ep4gpb60"
} : {
  target: "ep4gpb60",
  label: "Wrapper"
})("min-height:100vh;width:auto;background-color:", ({
  theme
}) => theme.bg, ";");
const AppShell = ({
  themeUrl,
  defaultTextColor,
  globalsFolder,
  children
}) => {
  const {
    appTheme,
    globals
  } = (0, _useSnorreTheme.default)({
    themeUrl,
    defaultTextColor,
    globalsFolder
  });
  return appTheme && globals ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react2.ThemeProvider, {
    theme: appTheme,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.Global, {
      styles: /*#__PURE__*/(0, _react2.css)(globals, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:AppShell;"))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
      children: children
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppLoader.default, {});
};
var _default = exports.default = AppShell;